import { CommissionsStatusEnum } from '@sparling/financial-common'

const statuses = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const status in CommissionsStatusEnum) {
  statuses.push({
    value: status,
    label: CommissionsStatusEnum[status as keyof typeof CommissionsStatusEnum],
  })
}

export const CRM_COMMISSIONS_STATUS = statuses
